module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/437.be737486.png";